<template>
  <div>

    <ok-cancel-modal
      :title="'Nuevo Alimento'"
      :ok-button="$t('commons.ok')"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk"
      v-on:cancel="$emit('close')">
      <div slot="body">
        <alert
          v-if="alertVisible"
          :message="alertMessage"
          :type="alertType">
        </alert>
        <div>
          <multi-select :options="options"
                        :selected-options="items"
                        placeholder="Añadir una propiedad"
                        @select="onSelect">
          </multi-select>
        </div>
        <div class="two-column-div" style="padding-top: 0.4rem" id="myForm">

          <label-input
            ref="esName"
            form-size="m"
            :label="'Nombre: '"
            :margin="false"
            v-on:input="(value) => {this.esName = value}"
            v-on:click="onInputResetBorder"
            required>
          </label-input>

          <label-input
            ref="enName"
            form-size="m"
            :label="'Name: '"
            :margin="false"
            v-on:input="(value) => {this.enName = value}"
            required>
          </label-input>

          <label-input
            ref="marca"
            form-size="m"
            :label="'Marca: '"
            :margin="false"
            v-on:input="(value) => {this.marca = value}">
          </label-input>

          <label-input
            type="Number"
            ref="group"
            form-size="m"
            :label="'Grupo: '"
            :margin="false"
            v-on:input="(value) => {this.group = value}"
            required>
          </label-input>

          <label-input
            type="Number"
            ref="Portion"
            form-size="m"
            :label="'Porción: '"
            :margin="false"
            v-on:input="(value) => {this.portion = value}"
            required>
          </label-input>

          <label-input
            type="Number"
            ref="kcal"
            form-size="m"
            :label="'Energía (kcal) en 100g: '"
            :value=this.kCals
            :margin="false"
            v-on:input="(value) => {
                this.kCals = value;
                updatekJoules();
              }"
            v-on:click="onInputResetBorder"
            required>
          </label-input>

          <label-input
            type="Number"
            ref="kjoule"
            form-size="m"
            :label="'Energia (kJ) en 100g: '"
            :value=this.kJoule
            :margin="false"
            v-on:input="(value) => {
                this.kJoule = value;
                updatekCals();
              }"
            v-on:click="onInputResetBorder"
            required>
          </label-input>

          <label-input
            type="Number"
            ref="fat"
            form-size="m"
            :label="'Grasas (g) en 100g: '"
            :value=this.fats
            :margin="false"
            v-on:input="(value) => {
                this.fats = value;
                updateInsaturated();
              }"
            v-on:click="onInputResetBorder"
            required
            under100>
          </label-input>

          <label-input
            type="Number"
            ref="saturated"
            form-size="m"
            :disabled="false"
            :label="'Grasas saturadas (g) en 100g: '"
            :value="this.saturated"
            v-on:input="(value) => {
                this.saturated = value
                updateInsaturated()
              }"
            :margin="false">
          </label-input>

          <label-input
            type="Number"
            ref="unsaturated"
            form-size="m"
            :disabled="true"
            :label="'Grasas insaturadas (g) en 100g: '"
            :value="this.insaturated"
            v-on:input="(value) => {this.insaturated = value}"
            :margin="false">
          </label-input>

          <label-input
            type="Number"
            ref="mono"
            form-size="m"
            v-on:input="(value) => this.mono = value"
            :label="'Acido Graso Monoinsaturado (g): '"
            :margin="false">
          </label-input>

          <label-input
            type="Number"
            ref="poli"
            form-size="m"
            :label="'Acido Graso Poliinsaturado (g): '"
            v-on:input="(value) => {this.poli = value}"
            :margin="false">
          </label-input>

          <label-input
            type="Number"
            ref="carbs"
            form-size="m"
            :label="'Carbs (g): '"
            :margin="false"
            v-on:input="(value) => {this.carbs = value}"
            required>
          </label-input>

          <label-input
            type="Number"
            ref="sugar"
            form-size="m"
            :label="'Azúcares: '"
            v-on:input="(value) => {this.sugar = value}"
            :margin="false"/>

          <label-input
            type="Number"
            ref="fiber"
            form-size="m"
            :label="'Fibra (g): '"
            :margin="false"
            v-on:input="(value) => {this.fiber = value}"
            required>
          </label-input>

          <label-input
            type="Number"
            ref="protein"
            form-size="m"
            :label="'Proteinas (g): '"
            :margin="false"
            v-on:input="(value) => {this.proteins = value}"
            required>
          </label-input>

          <label-input
            type="Number"
            ref="salt"
            form-size="m"
            :label="'Sal: '"
            v-on:input="(value) => {this.salt = value}"
            :margin="false"/>
        </div>
      </div>

    </ok-cancel-modal>
  </div>
</template>

<script>
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import SearchInput from '@/components/shared/SearchInput';
import Radio from '@/components/shared/forms/Radio';
import LabelInput from '@/components/shared/forms/LabelInput';
import {MultiSelect} from 'vue-search-select';
import Alert from '@/components/shared/alert/Alert';
import api from 'BRAND/api/foodManager';

export default {
  name: 'AddFoodModal',
  components: {
    OkCancelModal,
    SearchInput,
    Radio,
    LabelInput,
    MultiSelect,
    Alert
  },
  props: {},
  data () {
    return {
      foodFilter: '',
      selectedFood: null,
      esName: '',
      enName: '',
      portion: null,
      group: null,
      proteins: null,
      fats: null,
      kJoule: null,
      kCals: null,
      carbs: null,
      fiber: null,
      salt: null,
      sugar: null,
      mono: 0,
      poli: 0,
      insaturated: 0,
      saturated: 0,
      foodId: null,
      marca: '',
      alertVisible: false,
      alertMessage: '',
      options: [
        {value: '1', text: 'Agua', property: 'atriAgua'},
        {value: '2', text: 'Alcohol', property: 'atriAlcohol'},
        {value: '3', text: 'Deporte', property: 'atriDeporte'},
        {value: '4', text: 'Estimulante', property: 'atriEstimulante'},
        {value: '5', text: 'Pre-ejercicio', property: 'atriPreSport'},
        {value: '6', text: 'Durante-ejercicio', property: 'atriDuringSport'},
        {value: '7', text: 'Post-ejercicio', property: 'atriPostSport'},
        {value: '8', text: 'Fibra', property: 'atriFibra'},
        {value: '9', text: 'Azúcar añadido', property: 'atriSugarAdd'},
        {value: '10', text: 'Azúcar libre', property: 'atriSugarFree'},
        {value: '11', text: 'Natural', property: 'atriNatural'},
        {value: '12', text: 'Procesado', property: 'atriProcessed'},
        {value: '13', text: 'Ultraprocesado', property: 'atriUltraprocessed'},
        {value: '14', text: 'Sin gluten', property: 'atriGlutenFree'},
        {value: '15', text: 'Vegetariano', property: 'atriVegetarian'},
        {value: '16', text: 'Vegano', property: 'atriVegan'},
        {value: '17', text: 'Sin lactosa', property: 'atriLactoseFree'},
        {value: '18', text: 'Antiinflamatorio', property: 'atriAntiinflammatory'},
        {value: '19', text: 'Antiinflamatorio posible', property: 'atriPosibleAntiinflammatory'},
        {value: '20', text: 'Antioxidante', property: 'atriAntioxidant'},
        {value: '21', text: 'Antioxidante posible', property: 'atriPosibleAntioxidant'},
        {value: '22', text: 'IG alto', property: 'atriHighGlycemicIndex'},
        {value: '23', text: 'IG medio', property: 'atriMediumGlycemicIndex'},
        {value: '24', text: 'Alto en proteina', property: 'atriHighProtein'},
        {value: '25', text: 'Valor biológico proteina alto', property: 'atriHighProteinBiologicalValue'},
        {value: '26', text: 'Valor biológico proteina medio', property: 'atriMediumProteinBiologicalValue'},
        {value: '27', text: 'Alto en grasa saturadas', property: 'atriHighSaturatedFat'},
        {value: '28', text: 'Alto en grasa trans', property: 'atriHighTransFat'},
        {value: '29', text: 'Alto en HC refinados', property: 'atriHighRefinedCarbohydrates'},
        {value: '30', text: 'Integral', property: 'atriIntegral'},
        {value: '31', text: 'Integral medio', property: 'atriMediumIntegral'},
        {value: '32', text: 'FODMAP', property: 'atriFodmap'},
        {value: '33', text: 'Fe', property: 'atriFe'},
        {value: '34', text: 'OMEGA-3', property: 'atriOmega3'},
        {value: '35', text: 'Ácido fólico', property: 'atriFolidAcid'},
        {value: '36', text: 'Calcio', property: 'atriCalcium'},
        {value: '37', text: 'Vit D', property: 'atriVitaminD'},
        {value: '38', text: 'Embarazo', property: 'atriPregnancy'},
        {value: '39', text: 'Menopausia', property: 'atriMenopause'}
      ],
      items: []
    };
  },
  methods: {
    onOk () {
      let requieredFieldError = false;
      document.getElementById('myForm').querySelectorAll('[required]').forEach(function (i) {
        if (i.querySelector('input').value === '') {
          i.querySelector('input').style.border = '1px solid red';
          requieredFieldError = true;
        }
      });
      if (requieredFieldError) {
        this.alertVisible = true;
        this.alertMessage = 'Por favor, rellene todos los campos requeridos';
        this.alertType = 'error';
        setTimeout(() => {
          this.alertVisible = false;
        }, 2000);
      }
      let attributes = {};
      for (let i = 0; i < this.items.length; i++) {
        let item = this.items[i];
        const property = item.property;
        attributes[property] = true;
      }
      if (!requieredFieldError) {
        let food = {
          foodEspName: this.esName,
          foodEngName: this.enName,
          portion: this.portion,
          foodGroupId: this.group,
          proteinGramValue: this.proteins,
          fatGramsValue: this.fats,
          energykJValue: this.kJoule,
          carbohydrateGramValue: this.carbs,
          fibreGramValue: this.fiber,
          sugar: this.sugar,
          salt: this.salt,
          monounsaturatedFattyAcid: this.mono,
          polyunsaturatedFattyAcid: this.poli,
          unsaturatedFattyAcid: this.insaturated,
          saturatedFattyAcid: this.saturated,
          marca: this.marca,
          ...attributes
        };
        this.sendData(food);
      }
    },
    sendData (food) {
      api.addNewFood(this, food).then(() => {
        this.alertVisible = true;
        this.alertMessage = 'Alimento añadido correctamente';
        this.alertType = 'success';
        setTimeout(() => {
          this.$emit('close');
        }, 1000);
      }).catch((error) => {
        this.alertVisible = true;
        this.alertMessage = error.body.message;
        this.alertType = 'error';
        setTimeout(() => {
          this.alertVisible = false;
        }, 1000);
      });
    },
    onInputResetBorder (event) {
      event.target.style.border = '1px solid #d9d9d9';
    },
    onCancel () {
      this.$emit('close');
    },
    onSelect (items, lastSelectItem) {
      this.items = items;
      this.lastSelectItem = lastSelectItem;
    },
    updateInsaturated () {
      this.insaturated = Math.round((this.fats - this.saturated) * 100) / 100;
    },
    updatekJoules () {
      const value = this.kCals * 4.184;
      this.kJoule = Math.round(value * 100) / 100;
    },
    updatekCals () {
      const value = this.kJoule / 4.184;
      this.kCals = Math.round(value * 100) / 100;
    }
  }
};

</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

h3 {
  color: $jamaicol;
}

.two-column-div {
  display: grid;
  grid-template-rows: repeat(6, auto);
  grid-gap: 10px;
  grid-auto-flow: column;
}

.food-list {
  min-height: calc(100vh / 2);
  max-height: calc(100vh / 2);
  overflow-y: auto;
}

.search-input {
  margin-bottom: $sp-margin;
}

.and-x-more {
  color: $jamaicol;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/workspace/FoodAddModal.vue